var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.offer)?_c('v-col',{staticClass:"mx-auto mt-md-5",attrs:{"cols":"12","md":"10","lg":"10"}},[_c('OfferPage',{attrs:{"offer":_vm.offer,"inDialog":false}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }